module.exports = __webpack_public_path__ + "static/media/Trends.b77aa4b2.jpg";